export type IsoImplementationStandard = 'iso9001' | 'iso14001' | 'iso27001' | 'iso45001';

export interface IsoImplementationAnnexRoute {
  path: string;
  label: string;
  guideSlug: string;
}

export interface IsoImplementationStandardMeta {
  label: string;
  basePath: string;
  progressPath: string;
  roadmapPath?: string;
  deliverablesPath?: string;
  guidePath?: string;
  annexes?: IsoImplementationAnnexRoute[];
}

export const ISO_IMPLEMENTATION_META: Record<IsoImplementationStandard, IsoImplementationStandardMeta> = {
  iso9001: {
    label: 'ISO 9001',
    basePath: '/iso9001/implementacion',
    progressPath: '/iso9001/implementacion/avance',
    roadmapPath: '/iso9001/implementacion/hoja-ruta',
    deliverablesPath: '/iso9001/implementacion/entregables',
    guidePath: '/iso9001/implementacion/guia',
  },
  iso14001: {
    label: 'ISO 14001',
    basePath: '/iso14001/implementacion',
    progressPath: '/iso14001/implementacion/avance',
    roadmapPath: '/iso14001/implementacion/hoja-ruta',
    deliverablesPath: '/iso14001/implementacion/entregables',
    annexes: [
      {
        path: '/iso14001/implementacion/aia',
        label: 'Matriz AIA',
        guideSlug: 'aia',
      },
    ],
  },
  iso27001: {
    label: 'ISO 27001',
    basePath: '/iso27001/implementacion',
    progressPath: '/iso27001/implementacion/avance',
    roadmapPath: '/iso27001/implementacion/hoja-ruta',
    deliverablesPath: '/iso27001/implementacion/entregables',
    guidePath: '/iso27001/implementacion/guia',
    annexes: [
      {
        path: '/iso27001/soa',
        label: 'Anexo A (SoA)',
        guideSlug: 'anexo-a',
      },
    ],
  },
  iso45001: {
    label: 'ISO 45001',
    basePath: '/iso45001/implementacion',
    progressPath: '/iso45001/implementacion/avance',
    roadmapPath: '/iso45001/implementacion/hoja-ruta',
    deliverablesPath: '/iso45001/implementacion/entregables',
    guidePath: '/iso45001/implementacion/guia',
  },
};

export function isIsoImplementationStandard(value: string): value is IsoImplementationStandard {
  return value in ISO_IMPLEMENTATION_META;
}

export function standardGuideLabel(_standard: IsoImplementationStandard, guideSlug: string): string {
  if (guideSlug === 'guia') return 'Guía';
  if (guideSlug === 'hoja-ruta') return 'Hoja de ruta';
  if (guideSlug === 'entregables') return 'Entregables';
  if (guideSlug === 'aia') return 'Matriz AIA';
  if (guideSlug === 'anexo-a') return 'Anexo A';
  return guideSlug;
}
